import React from "react";

import AppStoreSource from "./app-store.png";
import GooglePlaySource from "./google-play.png";
import { Container, Icon, IconContainer, StyledBaseLink, Title } from "./styles";

export type Props = {
  className?: string;
  onClick: (destination: string) => void;
};

export const HomeFooterDownloadAppWidget: React.FunctionComponent<Props> = ({
  className,
  onClick,
}) => {
  const renderUrl = (children: JSX.Element) => (
    <StyledBaseLink
      pathname="https://scmp.onelink.me/3586748601/43f04bbb"
      onClick={() => onClick("https://scmp.onelink.me/3586748601/43f04bbb")}
    >
      {children}
    </StyledBaseLink>
  );

  return (
    <Container className={className}>
      <Title>Read more in the SCMP App</Title>
      <IconContainer>
        {renderUrl(<Icon alt="app store" src={AppStoreSource.src} />)}
        {renderUrl(<Icon alt="google play" src={GooglePlaySource.src} />)}
      </IconContainer>
    </Container>
  );
};

HomeFooterDownloadAppWidget.displayName = "HomeFooterDownloadAppWidget";
